import { WebViewBridgeProvider } from '@fourthwall/webview-bridge';
import React from 'react';
export const WebViewProvider = ({ children }) => (React.createElement(WebViewBridgeProvider, { userAgent: window.navigator.userAgent }, children));
